import { createActionCreators } from "../utils/actionCreators";

export const {
    request: getEmployeeRequest,
    success: getEmployeeSuccess,
    failure: getEmployeeFailure
} = createActionCreators('GET_EMPLOYEE');

export const {
    request: setEmployeeRequest,
    success: setEmployeeSuccess,
    failure: setEmployeeFailure
} = createActionCreators('SET_EMPLOYEE');

export const {
    request: createEmployeeRequest,
    success: createEmployeeSuccess,
    failure: createEmployeeFailure
} = createActionCreators('CREATE_EMPLOYEE');

export const {
    request: updateEmployeeRequest,
    success: updateEmployeeSuccess,
    failure: updateEmployeeFailure
} = createActionCreators('UPDATE_EMPLOYEE');

export const {
    request: addEmployeeFilesRequest,
    success: addEmployeeFilesSuccess,
    failure: addEmployeeFilesFailure
} = createActionCreators('ADD_EMPLOYEE_FILES');

export const {
    request: removeEmployeeFileRequest,
    success: removeEmployeeFileSuccess,
    failure: removeEmployeeFileFailure
} = createActionCreators('REMOVE_EMPLOYEE_FILE');